import { render, staticRenderFns } from "./ConsignerConsumptionTable.vue?vue&type=template&id=a53a7ea8&scoped=true&"
import script from "./ConsignerConsumptionTable.vue?vue&type=script&lang=ts&"
export * from "./ConsignerConsumptionTable.vue?vue&type=script&lang=ts&"
import style0 from "./ConsignerConsumptionTable.vue?vue&type=style&index=0&id=a53a7ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53a7ea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDivider,VList,VListGroup,VListItemAvatar,VListItemContent,VListItemTitle,VProgressCircular,VSimpleTable})
